import { DateTime } from 'luxon';
import { activeStatus } from '../../constants/events';
import {
  catalogOrderingApiToUrl,
  catalogOrderingUrlToApi,
} from '../../lib/consts';
import { PickedCatalogQueryFilters } from '../../components/pages/catalog-events/model';
import {
  CategoryShort,
  CategoryShortWithChildrenCategoryShort,
} from '../../models/categories';
import { City } from '../../models';
import { FilterQuery } from '../../models/filters';

export const getPathFromQuery = ({
  defaultCatalogPathnameWithCurrentCity,
  query,
  categories,
}: {
  defaultCatalogPathnameWithCurrentCity: string;
  query: PickedCatalogQueryFilters;
  categories: CategoryShortWithChildrenCategoryShort[];
}) => {
  let querySubcategoriesSlugs: string[] = [];
  const { category: queryCategory, subcategories: querySubcategories } =
    query.filters.categories;
  const currentCategory: CategoryShortWithChildrenCategoryShort | undefined =
    categories.find(
      (item: CategoryShortWithChildrenCategoryShort) =>
        item.id === queryCategory
    );

  if (!currentCategory) {
    return {
      pathname: defaultCatalogPathnameWithCurrentCity,
      querySubcategoriesSlugs: [],
    };
  }
  let pathname = `${defaultCatalogPathnameWithCurrentCity}${currentCategory.slug}/`;
  querySubcategories.forEach((item: number) => {
    const currentSubcategory = currentCategory.children?.find(
      (child: CategoryShort) => child.id === item
    );

    if (currentSubcategory) {
      querySubcategoriesSlugs.push(currentSubcategory.slug);
    }
  });

  if (querySubcategoriesSlugs.length === 1) {
    pathname = `${defaultCatalogPathnameWithCurrentCity}${currentCategory.slug}/${querySubcategoriesSlugs[0]}/`;
    querySubcategoriesSlugs = [];
  }

  if (currentCategory.children.length !== querySubcategoriesSlugs.length) {
    return { pathname, querySubcategoriesSlugs };
  }

  return { pathname, querySubcategoriesSlugs: [] };
};

export const getRouterOptionsFromQuery = ({
  query,
  querySubcategories,
}: any) => {
  const price = Array.isArray(query.filters.filter_price__gte)
    ? []
    : [query.filters.filter_price__gte, query.filters.filter_price__lte];

  const startDate2 = Array.isArray(query.filters.date_from)
    ? []
    : [
        DateTime.fromISO(query.filters.date_from).toFormat('dd.LL.yyyy'),
        DateTime.fromISO(query.filters.date_to).toFormat('dd.LL.yyyy'),
      ];

  const { pages } = query.filters;

  if (Array.isArray(pages)) {
    if (pages.filter((x) => x === 1).length === 2) {
      pages.length = 0;
    }
  }

  let sort = Array.isArray(query.filters.sort) ? [] : query.filters.sort;

  if (sort === catalogOrderingApiToUrl['-views_per_3days']) {
    sort = [];
  }

  return {
    price,
    start_date2: startDate2,
    pages,
    sort,
    categories: querySubcategories,
  };
};

export const getSortType = (sort: any) => {
  if (!sort) return catalogOrderingUrlToApi.popular;
  if (Array.isArray(sort) && sort.length === 0)
    return catalogOrderingUrlToApi.popular;
  const sortType = Object.entries(catalogOrderingApiToUrl).filter(
    (entry) => entry[1] === sort
  );

  if (sortType.length) {
    return sortType[0][0];
  }
  return [];
};

export const getRequestOptions = ({
  query,
  limitOfCards,
  offsetOfCards,
  currentCity,
  categories,
}: {
  query: FilterQuery;
  limitOfCards: number;
  offsetOfCards: number;
  currentCity: City;
  categories: CategoryShortWithChildrenCategoryShort[];
}) => {
  const currentCategory = categories.find(
    (item) => item.id === query.filters.categories.category
  );
  const isAllCategoriesChecked =
    currentCategory?.children.length ===
    query.filters.categories.subcategories.length;

  const requestCategories = isAllCategoriesChecked
    ? typeof query.filters.categories.category === 'number'
      ? [
          query.filters.categories.category,
          ...query.filters.categories.subcategories,
        ]
      : query.filters.categories.subcategories
    : query.filters.categories.subcategories;

  return {
    limit: limitOfCards,
    offset: offsetOfCards,
    is_web: true,
    city: currentCity.id,
    status: activeStatus,
    ordering: getSortType(query.filters.sort) as string,
    // ordering: query.filters.sort,
    filter_price__gte: query.filters.filter_price__gte as number,
    filter_price__lte: query.filters.filter_price__lte as number,
    date_from: query.filters.date_from as string,
    date_to: query.filters.date_to as string,
    with_cards: true,
    categories: requestCategories,
  };
};

export const getLimitOffsetForCatalogPage = ({
  filters,
  isNewData,
  firstPageLimitOfCards,
  limitOfCardOtherPages,
}: any) => {
  let limitOfCards = limitOfCardOtherPages;
  let offsetOfCards = 0;
  if (filters.pages.length === 0) {
    limitOfCards = firstPageLimitOfCards;
    offsetOfCards = 0;
  } else if (filters.pages.length > 1) {
    if (isNewData) {
      limitOfCards = limitOfCardOtherPages;
      offsetOfCards =
        firstPageLimitOfCards + (filters.pages[1] - 2) * limitOfCardOtherPages;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (Number(filters.pages[0]) === 1) {
        limitOfCards =
          firstPageLimitOfCards +
          (filters.pages[1] - 1) * limitOfCardOtherPages;
        offsetOfCards = 0;
      } else {
        offsetOfCards =
          firstPageLimitOfCards +
          (filters.pages[0] - 2) * limitOfCardOtherPages;
        limitOfCards =
          (filters.pages[1] - filters.pages[0] + 1) * limitOfCardOtherPages;
      }
    }
  }
  return { limitOfCards, offsetOfCards };
};
